import { YandexUser } from '@/types/yandex';

export const SHOW_ALL_TOGGLE_UID = '__show_all_toggle__';

export const TOGGLE_OPTION: YandexUser = {
  uid: SHOW_ALL_TOGGLE_UID,
  display: '',
  email: '',
};
